import {Component, Input} from '@angular/core';
import {PatientErrorFieds} from '@drl/shared/models/csv-upload-report.model';

@Component({
  selector: 'app-patients-report',
  templateUrl: './patients-report.component.html',
  styleUrls: [],
})
export class PatientsReportComponent {
  @Input() patientsErrors: PatientErrorFieds[];
}
